import React from 'react';
import { Box, Button, Card, CardContent, CardHeader, Container, Divider, Grid, InputLabel, makeStyles, MenuItem, TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Formik } from 'formik';
import MaterialTable from "material-table";
import { Fragment, useEffect, useState } from 'react';
import { useAlert } from "react-alert";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { trackPromise } from 'react-promise-tracker';
import { useNavigate } from 'react-router-dom';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import * as Yup from "yup";
import { LoadingComponent } from '../../../utils/newLoader';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import services from '../Services';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    }
}));

const screenCode = 'SKUCATEGORY';

export default function SKUCategoryListing() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [budgetCodes, setBudgetCodes] = useState([]);
    const [IDDataForDeduction, setIsIDDataForDeduction] = useState(null);
    const [SKUCategoryNames, setSKUCategoryNames] = useState();
    const [SKUCategoryeViewData, setSKUCategoryeViewData] = useState([])
    const [isExecuteButtonDisabled, setIsExecuteButtonDisabled] = useState(false);
    const [SKUCategoryViewDetails, setSKUCategoryViewDetails] = useState({
        groupID: 0,
        factoryID: 0,
        budgetCodeID: 0,
        skuCategoryID: 0
    });

    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [selectedSKUCategoryID, setSelectedSKUCategoryID] = useState(0);
    let encrypted = "";
    const handleClick = () => {
        encrypted = btoa('0');
        navigate('/app/SKUCategory/addEdit/' + encrypted);
    }

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
    });

    useEffect(() => {
        getGroupsForDropdown();
        getBudgetCodeDetails();
    }, []);

    useEffect(() => {
        if (SKUCategoryViewDetails.budgetCodeID > 0 && SKUCategoryViewDetails.factoryID > 0) {
            trackPromise(getSKUCategoryNamesForDropdown());
        };
    }, [SKUCategoryViewDetails.budgetCodeID, SKUCategoryViewDetails.factoryID]);

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('accountType-listing-page-search-parameters-id')
        );
        getPermissions(IDdata);
        getBudgetCodeDetails();
    }, []);

    useEffect(() => {
        if (IDDataForDeduction !== null) {
            getData();
        }
    }, [IDDataForDeduction]);

    useEffect(() => {
        sessionStorage.removeItem(
            'accountType-listing-page-search-parameters-id'
        );
    }, []);

    useEffect(() => {
        setSKUCategoryeViewData([]);
    }, [SKUCategoryViewDetails.skuCategoryID]);

    useEffect(() => {
        if (SKUCategoryViewDetails.groupID != 0) {
            trackPromise(
                getFactoriesForDropdown(SKUCategoryViewDetails.groupID)
            );
        }
    }, [SKUCategoryViewDetails.groupID])

    useEffect(() => {
        if (SKUCategoryListing.budgetCodeID == 0) {
            setSKUCategoryViewDetails((prev) => ({
                ...prev,
                skuCategoryID: 0
            }))
            setSKUCategoryNames([]);
        };
    }, [SKUCategoryListing.budgetCodeID]);

    async function getPermissions(IDdata) {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSKUCATEGORY');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        const initialValues = IDdata === null;
        if (initialValues) {
            setSKUCategoryViewDetails({
                ...SKUCategoryViewDetails,
                groupID: parseInt(tokenService.getGroupIDFromToken()),
                factoryID: parseInt(tokenService.getFactoryIDFromToken()),
            })
        }
        else {
            setSKUCategoryViewDetails({
                ...SKUCategoryViewDetails,
                groupID: parseInt(IDdata.groupID),
                factoryID: parseInt(IDdata.factoryID),
                budgetCodeID: parseInt(IDdata.budgetCodeID),
                skuCategoryID: parseInt(IDdata.skuCategoryID)
            })
            setIsIDDataForDeduction(IDdata)
        }
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropdown(groupID) {
        const factories = await services.getAllFactoriesByGroupID(groupID);
        setFactories(factories);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    async function getBudgetCodeDetails() {
        var response = await services.getBudgetCodeDetails();
        setBudgetCodes(response);
    }

    async function getSKUCategoryNamesForDropdown() {
        const SKUCategoryNames = await services.GetSKUCategoryNamesByID(SKUCategoryViewDetails.budgetCodeID, SKUCategoryViewDetails.groupID, SKUCategoryViewDetails.factoryID);
        setSKUCategoryNames(SKUCategoryNames);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        if (e.target.name == "groupID") {
            setSKUCategoryViewDetails({
                ...SKUCategoryViewDetails,
                groupID: value,
                budgetCodeID: 0,
                skuCategoryID: 0
            });
        } else if (e.target.name == "budgetCodeID") {
            setSKUCategoryViewDetails({
                ...SKUCategoryViewDetails,
                budgetCodeID: value,
                skuCategoryID: 0
            });
        } else {
            setSKUCategoryViewDetails({
                ...SKUCategoryViewDetails,
                [e.target.name]: value
            });
        }
        setSKUCategoryeViewData([]);
    }

    async function getData() {
        let model = {
            groupID: parseInt(SKUCategoryViewDetails.groupID),
            factoryID: parseInt(SKUCategoryViewDetails.factoryID),
            budgetCodeID: parseInt(SKUCategoryViewDetails.budgetCodeID),
            skuCategoryID: parseInt(SKUCategoryViewDetails.skuCategoryID)
        }

        let response = await services.GetSKUCategoryDetails(model);
        if (response.statusCode == "Success" && response.data.length != 0) {
            setSKUCategoryeViewData(response.data)
        }
        else {
            alert.error(response.message)
            clearFields();
        }
    }

    const handleClickEdit = (skuCategoryID) => {
        encrypted = btoa(skuCategoryID);
        let modelID = {
            groupID: parseInt(SKUCategoryViewDetails.groupID),
            factoryID: parseInt(SKUCategoryViewDetails.factoryID),
            budgetCodeID: parseInt(SKUCategoryViewDetails.budgetCodeID),
            skuCategoryID: parseInt(SKUCategoryViewDetails.skuCategoryID)
        };
        sessionStorage.setItem(
            'accountType-listing-page-search-parameters-id',
            JSON.stringify(modelID)
        );
        navigate('/app/SKUCategory/addEdit/' + encrypted);
    }

    const handleConfirmDelete = async () => {
        setDeleteConfirmationOpen(false);
        let model = {
            skuCategoryID: selectedSKUCategoryID,
            modifiedBy: parseInt(tokenService.getUserIDFromToken())
        }
        const res = await services.DeleteSKUCategoryDetails(model);
        if (res.statusCode == "Success") {
            alert.success(res.message)
            trackPromise(getData())
        }
        else {
            alert.error(res.message)
        }
    };

    const handleCancelDelete = () => {
        setDeleteConfirmationOpen(false);
    };

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                        isEdit={true}
                        toolTiptitle={"Add SKU Category"}
                    />
                </Grid>
            </Grid>
        )
    }

    function clearFields() {
        setSKUCategoryViewDetails({
            ...SKUCategoryViewDetails
        });
        setSKUCategoryeViewData([]);
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title="SKU Category"
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: SKUCategoryViewDetails.groupID,
                            factoryID: SKUCategoryViewDetails.factoryID,
                            budgetCodeID: SKUCategoryViewDetails.budgetCodeID
                        }}

                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                budgetCodeID: Yup.number().required('Account Code Name required').min("1", 'Account Code Name is required'),
                            })
                        }
                        onSubmit={() => trackPromise(getData())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle("SKU Category")}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={SKUCategoryViewDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            fullWidth
                                                            name="factoryID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={SKUCategoryViewDetails.factoryID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="budgetCodeID">
                                                            Account Code Name *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.budgetCodeID && errors.budgetCodeID)}
                                                            fullWidth
                                                            helperText={touched.budgetCodeID && errors.budgetCodeID}
                                                            size='small'
                                                            name="budgetCodeID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={SKUCategoryViewDetails.budgetCodeID}
                                                            variant="outlined"
                                                            id="budgetCodeID"
                                                        >
                                                            {generateDropDownMenu(budgetCodes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="skuCategoryID">
                                                            Category Name
                                                        </InputLabel>
                                                        <Autocomplete
                                                            options={SKUCategoryNames || []}
                                                            getOptionLabel={(option) => option.skuCategoryName ? option.skuCategoryName.toString() : ""}
                                                            value={(SKUCategoryNames && SKUCategoryNames.find((SKUCategoryName) => SKUCategoryName.skuCategoryID === SKUCategoryViewDetails.skuCategoryID)) || null}
                                                            onChange={(event, newValue) => {
                                                                setSKUCategoryViewDetails((prev) => ({
                                                                    ...prev,
                                                                    skuCategoryID: newValue ? newValue.skuCategoryID : 0
                                                                }));
                                                            }}
                                                            renderInput={(params) => (<TextField
                                                                {...params}
                                                                error={Boolean(touched.skuCategoryID && errors.skuCategoryID)}
                                                                fullWidth
                                                                helperText={touched.skuCategoryID && errors.skuCategoryID}
                                                                variant="outlined"
                                                                size="small"
                                                                placeholder="--Select Category Name--"
                                                            />)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                            <Box minWidth={1050}>
                                                {SKUCategoryeViewData.length > 0 ? (
                                                    <MaterialTable
                                                        title="Multiple Actions Preview"
                                                        columns={[
                                                            { title: 'Category Code', field: 'skuCategoryCode' },
                                                            { title: 'Category Name', field: 'skuCategoryName' },
                                                            { title: 'Category Description', field: 'skuCategoryDescription', render: rowData => rowData.skuCategoryDescription ? rowData.skuCategoryDescription : "-" },
                                                            { title: 'Status', field: 'isActive', render: rowData => rowData.isActive == true ? "Active" : "Inactive" },
                                                        ]}
                                                        data={SKUCategoryeViewData}
                                                        options={{
                                                            exportButton: false,
                                                            showTitle: false,
                                                            headerStyle: { textAlign: "left", height: '1%' },
                                                            cellStyle: { textAlign: "left" },
                                                            columnResizable: false,
                                                            actionsColumnIndex: -1,
                                                            pageSize: 10
                                                        }}
                                                        actions={[
                                                            {
                                                                icon: 'edit',
                                                                tooltip: 'Edit',
                                                                disabled: isExecuteButtonDisabled,
                                                                onClick: (event, rowData) => handleClickEdit(rowData.skuCategoryID)
                                                            }
                                                        ]}
                                                    />
                                                ) : null}
                                            </Box>

                                            <Dialog open={deleteConfirmationOpen} onClose={handleCancelDelete}>
                                                <DialogTitle>
                                                    <h2>Delete Confirmation</h2>
                                                </DialogTitle>
                                                <DialogContent>
                                                    <p>Are you sure you want to delete this record?</p>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleConfirmDelete} color="primary">
                                                        Delete
                                                    </Button>
                                                    <Button onClick={handleCancelDelete} color="primary">
                                                        Cancel
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>

                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page >
        </Fragment>
    )
}
